import React, { useEffect, useState } from "react";
import { useSetState } from "react-use";

import { create } from "../../services/Bitly";
import { shorten } from "../../services/Yourls";
import Builder from "../../services/LinkBuilder";
import GenerateLinksButtons from "./GenerateLinksButtons";

import "./index.css";
import Fields from "./Fields";
import ShortenedLinks from "./ShortenedLinks";

let errors = [];
errors["INVALID_ARG_LONG_URL"] = "Link da vaga Inválida";

export default function StepFormRow(props) {
  const [resultLinks, updateResultLinks] = useSetState({
    bitlink: "",
    longUrl: "",
    shortenerError: "",
    yourl: "",
  });

  const [job, updateJob] = useSetState({
    originUrl: props.job.link,
    campaign: props.job.campaign,
  });

  const [selectedFields, updateSelectedFields] = useSetState({
    channel: "",
    source: "",
    medium: "",
    content: "",
    customUrl: "",
  });

  const [shouldRenderUTMs, setShouldRenderUTMs] = useState(false);

  const { checkUrl } = props;

  useEffect(() => {
    updateResultLinks({
      longUrl: Builder({
        originUrl: job.originUrl,
        campaign: job.campaign,
        content: selectedFields.content,
        channel: selectedFields.channel,
        source: selectedFields.source,
        medium: selectedFields.medium,
      }),
    });
  }, [checkUrl, job, props, selectedFields, updateResultLinks]);

  useEffect(() => {
    updateJob({
      campaign: props.job.campaign,
      originUrl: props.job.link,
    });
  }, [props.job, updateJob]);

  useEffect(() => {
    setShouldRenderUTMs(
      job.originUrl &&
        job.campaign &&
        selectedFields.channel &&
        selectedFields.source &&
        selectedFields.medium &&
        checkUrl(job.originUrl)
    );
  }, [checkUrl, job, selectedFields, updateJob]);

  const handleErase = () => {
    updateJob({
      campaign: "",
      medium: "",
      content: "",
      channel: "",
      source: "",
      customUrl: "",
    });
  };

  const generateBitilink = async (event) => {
    create(resultLinks.longUrl)
      .then(async (data) => {
        updateResultLinks({ bitlink: data.data.link });
      })
      .catch((error) => {
        alert(errors[error.response.data.message]);
      });
  };

  const generateYourls = async (event) => {
    shorten(
      resultLinks.longUrl,
      selectedFields.customUrl,
      (result, response) => {
        if (response.status === "fail") {
          updateResultLinks({ shortenerError: response.message });
        }
        updateResultLinks({ yourl: response.shorturl });
      }
    );
  };

  const transformBitlyForLinkedin = (input) => {
    return `[${input}]`;
  };

  const transformYourlsForLinkedin = (url) => {
    return url.replace("https://", "");
  };

  const getAdjustedBitlyLink = () => {
    if (!resultLinks.bitlink) {
      return "";
    }

    if (selectedFields.source === "linkedin") {
      return transformBitlyForLinkedin(resultLinks.bitlink);
    }

    return resultLinks.bitlink;
  };

  const getAdjustedYourls = () => {
    if (!resultLinks.yourl) {
      return "";
    }

    if (selectedFields.source === "linkedin") {
      return transformYourlsForLinkedin(resultLinks.yourl);
    }

    return resultLinks.yourl;
  };

  return (
    <li className="list-group-item">
      <Fields
        selectedFields={selectedFields}
        updateSelectedFields={updateSelectedFields}
      />

      {shouldRenderUTMs && (
        <GenerateLinksButtons
          selectedFields={selectedFields}
          generateByInteraShorteners={generateYourls}
          generateBitly={generateBitilink}
        />
      )}

      <button className="btn btn-sm btn-danger" onClick={handleErase}>
        Limpar
      </button>

      <br />

      {shouldRenderUTMs && (
        <ShortenedLinks
          links={{
            bitlyLink: getAdjustedBitlyLink(),
            byInteraInLink: getAdjustedYourls(),
            longUrl: resultLinks.longUrl,
          }}
          error={{
            errorMessage: resultLinks.shortenerError,
            hasError: !!resultLinks.shortenerError,
          }}
        />
      )}
    </li>
  );
}
